import mustBeFiltered from '@/Framework/browser/log/sentry/filter/mustBeFiltered';

export default mustBeFiltered;
